import * as React from "react";
import {useEffect, useRef, useState} from "react";
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import _ from 'lodash';
import moment from 'moment/moment';
import {AdminAPI} from './admin_api';
import {setLoading} from '../../store/reducers/patient';
import Grid from '@mui/material/Grid';
import DateTimePicker from '@mui/lab/DateTimePicker';
import config from '../../app/config';
import TextField from '@mui/material/TextField';
import {TextFieldDebounce} from "../../controls/agyle/textFieldDebounce";
import FormControl from '@mui/material/FormControl';
import {
    Button, IconButton,
    InputLabel,
    MenuItem, OutlinedInput,
    Select,
    Table, TableBody,
    TableCell,
    TableContainer, TableFooter,
    TableHead,
    TableRow, Typography,
} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import {ArrowIconHL7, DatabaseIconHL7, DateIconHL7, ErrorIconHL7} from '../../components/icons/icons';
import NavigateBeforeSharpIcon from '@mui/icons-material/NavigateBeforeSharp';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Hl7utils from './hl7/hl7utils';
import {copyToClipboard} from './hl7/hl7_console';
import {setSnackbar} from '../../store/reducers/globals';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import * as _get from 'lodash/get';
import {ColumnTypes} from './hl7/hl7_messages_comp';
import {styled} from '@mui/styles';
import API from '../../app/api';

const StyledFormControl = styled(FormControl)(({ theme }) => ({
    '&.MuiOutlinedInput-root': {
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.25)",
        '&.Mui-focused fieldset': {
            borderColor: "#448FFF",
        },
    },
}));

const useStyles = makeStyles((theme) => ({
        typeSelect: {
            width: 150,
            height: 50,
            marginLeft: '15px',
        },
        typeSelectItem: {
            '&:hover': {
                backgroundColor: '#448FFF',
                color: 'white',
            }
        },
        agyleButton:{
            background: '#448FFF',
        },
        errorContainer: {
            cursor: "pointer",
            backgroundColor: "#FFECEC",
            maxWidth: "100%",
            borderRadius: "7px",
            marginBottom: "10px",
        },
        errorIconOuter: {
            minWidth: '85px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: '10px',
            marginRight: '10px',
        },
        errorIconInner: {
            height:'40px',
            width: '40px',
            backgroundColor: 'white',
            borderRadius: '50%',
            paddingLeft:'10px',
            paddingTop:'10px',
            boxShadow: '0 0 10px red'
        },
        errorContainerText: {
            marginTop: '20px',
            marginRight: '20px',
            marginBottom: '20px',
            wordBreak: 'initial'
        },
        spaceBetween: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',

        },
        textWithArrow: {
            cursor: "pointer",
            display: 'flex',
            gap: '5px'
        }
    })
)

const columnsWidths = {
    "Info": '100px',
    "Date": '300px',
    "Type": '170px',
    "Hospital number": '170px',
    "Actions": '200px',
    "Status": '170px'
};

function RowMessage (props) {
    const columns = props.columns;
    const row = props.row;
    const classes = useStyles();

    const dispatch = useDispatch();

    const [selected, setSelected] = React.useState(false);
    const [optionValue, setOptionValue] = React.useState('');
    const handleAddToSelectRows = (row) => {
        setSelected(!selected);
    }

    useEffect(()=>{
        if(props.handleAddRow && selected)
            props.handleAddRow(row);
        if(props.handleRemoveRow && !selected)
            props.handleRemoveRow(row);
    }, [selected])

    const checkMessage = (msg, nm)=> {
        switch(nm.key) {
            case "Copy JSON":
                if (!msg)
                    return dispatch(setSnackbar({open: true, message: `No message to copy`, severity: "error"}));
                return nm.props.onClick();

            case "Show JSON":
                if (!msg)
                    return dispatch(setSnackbar({open: true, message: `No message to show`, severity: "error"}));
                return nm.props.onClick();

            case "Details":
                return nm.props.onClick();
        }
    }

    return (<React.Fragment>
        {/*<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>*/}
        <TableRow hover role="checkbox" tabIndex={-1} key={row.code + props.rowIndex}>
            {columns.map((column, index) => {
                switch(column.type) {

                    case ColumnTypes.TEXT:
                        const value = _get(row, column.value);
                        return (
                            <TableCell key={props.rowIndex+index+"text"} align={column.align} >
                                {column.format
                                    ? column.format(value,column)
                                    : value}
                            </TableCell>
                        );

                    case ColumnTypes.ACTIONS:
                        let buttons = [];
                        column.actionList.forEach((action)=>{
                            buttons.push( <Button key={action.buttonLabel}
                                                  onClick={() => action.callback(row)}>{action.buttonLabel}</Button>)
                        })

                        return (
                            <TableCell key={props.rowIndex+"buttons"} align={column.align}>
                                <StyledFormControl className={classes.typeSelect}>
                                    <InputLabel>Select action</InputLabel>
                                    <Select
                                        input={<OutlinedInput />}
                                        value={optionValue}
                                        onChange={(selected) => {setOptionValue('')}}
                                    >
                                        {buttons.map((name) => {
                                            return (
                                                <MenuItem
                                                    className={classes.typeSelectItem}
                                                    key={name.key}
                                                    onClick={() => checkMessage(row.fhir, name)}
                                                    value="Select action"
                                                >
                                                    {name.key}
                                                </MenuItem>
                                            )
                                        })
                                        }
                                    </Select>
                                </StyledFormControl>
                            </TableCell>
                        )
                    case ColumnTypes.CHEACKBOX:
                        return (
                            <TableCell key={props.rowIndex+index+"ch"} align={column.align || 'center'} sx={{borderLeft: row.errorMessage ? "2px solid red": ""}}>
                                <Checkbox
                                    onChange={() => {handleAddToSelectRows(row)} }
                                    checked={selected}
                                    inputProps={{
                                        'aria-label': 'primary checkbox',
                                    }}
                                    color={'info'}
                                />
                            </TableCell>
                        )

                }

            })}
        </TableRow>
    </React.Fragment>)
}

function FHIRMessagesTable(props){
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const controller = new AbortController();
    const classes = useStyles();
    const [runSocket, setRunSocket] = React.useState(props.liveMessage);

    const [messages, setMessages] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [reSent, setReSent] = React.useState(0);
    const [sortSend, setSortSend]= React.useState(null);
    const [sortOrder, setSortOrder]= React.useState(false);
    const [messageType] = React.useState([{display:"Appointment",value:"Appointment"},{display:"Schedule",value:"Schedule"}]);
    const [messageTypeDict] = React.useState({Appointment:"operations",Schedule:"theatreSessions"});
    const [statuses] = React.useState(["pending","sent","error"]);
    const pageSize = 20;
    const [selectedRows, setSelectedRows] = React.useState([]);

    useEffect(() =>{
        if(props.columns.length) {
            let defaultSortItem = _.find(props.columns, {defaultSort: true})
            if(defaultSortItem) {
                setSortSend(defaultSortItem.value)
            } else {
                setSortSend("date")
            }
        }

    }, [props.columns])

    const [searchCriteria, setSearchCriteria] = React.useState({
        searchFromDay: moment().subtract(1, 'month'),
        searchToDay: moment(),
        hospitalNumber: "",
        messageType: "",
        status: "",
        searchErrors: false
    });
    const handleChangeNextPage = () => {
        setPage(page+1);
    };

    const handleChangePrevPage = () => {
        setPage(page-1);
    };

    const getFilter = () => {
        let filterchain = [];
        let from = `date gt_dt '${searchCriteria.searchFromDay.format('yyyy-MM-DD HH:mm')}'`;
        filterchain.push(from);
        let to = `date lt_dt '${searchCriteria.searchToDay.format('yyyy-MM-DD HH:mm')}'`
        filterchain.push(to);
        if (searchCriteria.hospitalNumber && searchCriteria.hospitalNumber.length) {
            let f = filterToRegex(searchCriteria.hospitalNumber);
            if (isRegex(searchCriteria.hospitalNumber)) {
                filterchain.push(`hospitalNumber regex '${f}'`);
            } else {
                filterchain.push(`hospitalNumber eq '${f}'`);
            }
        }
        if (searchCriteria.messageType && searchCriteria.messageType.length) {
            filterchain.push(`collection eq '${messageTypeDict[searchCriteria.messageType]}'`);
        }
        if (searchCriteria.status && searchCriteria.status.length) {
            filterchain.push(`status eq '${searchCriteria.status}'`);
        }
        if (searchCriteria.searchErrors) {
            filterchain.push('error eq true');
        }
        let filter = filterchain.join(' and ');
        return filter;
    }
    const filterToRegex = (str) => {
        if (str && str.length > 0) {
            if (str[0] === '%') {
                str = ".*" + str.substr(1);
            }
            if (str[str.length - 1] === '%') {
                str = str.substr(0, str.length - 2) + ".*";
            }
        }
        return str;
    }
    const isRegex = (str) => {
        if (str && str.length > 0) {
            if (str[0] === '%') {
                return true;
            }
            if (str[str.length - 1] === '%') {
                return true;
            }
        }
        return false;
    }
    
    useEffect(()=>{
        if(sortSend)
            getFHIRoutcomming();
    },[sortSend, sortOrder, page])
    
    useEffect(()=>{
        if(sortSend)
            getFHIRoutcomming();
    },[reSent])

    const getFHIRoutcomming = () => {
        if(sortSend) {
            dispatch(setLoading(true));
            getSetFilters();
            let sort = (sortOrder ? "" : "!") + sortSend;
            AdminAPI.getFHIRLog(getFilter(), page, pageSize, sort).then(tableData => {
                setMessages(tableData.data);
            }).finally(()=>{
                dispatch(setLoading(false));
            });
        }
    }
    useEffect(()=>{
        return () => {
            controller.abort();
        };
    }, [])
    const [filtersChip, setFilterChips] = React.useState([]);
    const getSetFilters = () => {
        let filters = [];
        if(searchCriteria.hospitalNumber) filters.push({filed: "hospitalNumber", value: searchCriteria.hospitalNumber})
        if(searchCriteria.status) filters.push({filed: "status", value: searchCriteria.status})
        if(searchCriteria.messageType) filters.push({filed: "messageType", value: searchCriteria.messageType})

        setFilterChips(filters)
    }
    const applyFilter = () => {
        if(!page) {
            getFHIRoutcomming();
        }  else
            setPage(0);
    }
    useEffect(()=>{
        if(doSearch.current) {
            applyFilter()
            doSearch.current = false;
        }
    },[searchCriteria])

    const doSearch = useRef(false);

    const handleDelete = (chip) => {
        doSearch.current = true;
        setSearchCriteria(prevState => ({...prevState, [chip.filed]: ""}));
    }
    const handleSetSort = (column) => {
        if(column.value === sortSend) {
            setSortOrder(!sortOrder)
        } else {
            setSortSend(column.value)
        }
    }
    const getColumnWidth = column => (columnsWidths[column?.description]|| '256px')
    const copyRowsMessage = () => {
        let stringToCopy = "";
        let count = 0;
        selectedRows.forEach((r) => {
            if(r.fhir) {
                if(stringToCopy.length>0) {
                    stringToCopy = stringToCopy + "\r\n\r\n";
                }
                stringToCopy = stringToCopy + JSON.stringify(r.fhir,null,2);
                count++;
            }
        });

        copyToClipboard(stringToCopy);
        dispatch(setSnackbar({type: "info", message: `${count} message/s has been copied!`}));
    }
    const resendMessages = () => {
        let ids = [];
        selectedRows.forEach((r) => {
            ids.push(r._id);
        });
        dispatch(setLoading(true));
        AdminAPI.resendFhir(ids).then(result => {
            dispatch(setSnackbar({type: "info", message: `${selectedRows.length} message/s has been re-sent!`}));
            dispatch(setLoading(false));
            setReSent(reSent+1);
        });
    }
    const renderFilters = () => {
        return( <Grid
            container
            spacing={2}
            justifyContent='center'
            alignItems='center'
            sx={{padding: '40px', borderRadius: '5px', marginBottom: '10px', border: "1px solid #448FFF", width: "100%", marginLeft: 0}}
        >
            <Grid item xs={6}>
                <DateTimePicker
                    label={t("Date From")}
                    inputFormat={config.defaultDateTimeFormat}
                    inputVariant="outlined"
                    clearable={true}
                    ampm={false}
                    value={searchCriteria.searchFromDay}
                    onChange={(value) => {
                        setSearchCriteria(prevState => ({...prevState, searchFromDay: value}))
                    }}
                    renderInput={(inp) => <TextField style={{width: "100%", margin: 0}} {...inp}
                                                     size={props.size}/>}
                />
            </Grid>
            <Grid item xs={6}>
                <DateTimePicker
                    label={t("Date To")}
                    inputFormat={config.defaultDateTimeFormat}
                    inputVariant="outlined"
                    clearable={true}
                    ampm={false}
                    value={searchCriteria.searchToDay}
                    onChange={(value) => {
                        setSearchCriteria(prevState => ({...prevState, searchToDay: value}))
                    }}
                    renderInput={(inp) => <TextField style={{width: "100%", margin: 0}} {...inp}
                                                     size={props.size}/>}
                />
            </Grid>
            <Grid item xs={4}>
                <FormControl variant="outlined" size={"medium"} style={{width: "100%"}}>
                    <InputLabel>{t("Message Type")}</InputLabel>
                    <Select
                        label={t("Message Type")}
                        value={searchCriteria.messageType}
                        onChange={(event)=> { setSearchCriteria(prevState => ({...prevState, messageType: event.target.value}))}}
                        fullWidth
                        renderValue={(selected) => {
                            return selected;
                        }}
                    >
                        {messageType.map((messageType, index) => (
                            <MenuItem
                                key={messageType.value+index}
                                value={messageType.value}

                                style={{display: 'flex', alignItems: 'center' }}
                            >
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <div>{messageType.display}</div>
                                </div>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>


            </Grid>
            <Grid item xs={4}>
                <FormControl variant="outlined" size={"medium"} style={{width: "100%"}}>
                    <InputLabel>{t("Status")}</InputLabel>
                    <Select
                        label={t("Status")}
                        value={searchCriteria.status}
                        onChange={(event)=> { setSearchCriteria(prevState => ({...prevState, status: event.target.value}))}}
                        fullWidth
                        renderValue={(selected) => {
                            return selected;
                        }}
                    >
                        {statuses.map((status, index) => (
                            <MenuItem
                                key={status+index}
                                value={status}

                                style={{display: 'flex', alignItems: 'center' }}
                            >
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <div>{status}</div>
                                </div>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={4}>
                <TextField
                    name={"value"}
                    label={t("Hospital Number")}
                    fullWidth
                    onChange={(event)=> { setSearchCriteria(prevState => ({...prevState, hospitalNumber: event.target.value}))}}
                    value={searchCriteria.hospitalNumber}
                    variant="outlined"
                />
            </Grid>
            {!props.outcoming && <Grid item xs={12}>
                <FormControlLabel
                    label={t("Only Errors")}
                    labelPlacement={"end"}
                    value={searchCriteria.searchErrors}
                    control={
                        <Checkbox
                            onChange={(event) => {
                                setSearchCriteria(prevState => ({...prevState, searchErrors: event.target.checked}))
                            }
                            }
                            checked={searchCriteria.searchErrors}
                            inputProps={{
                                'aria-label': 'primary checkbox',
                            }}
                            color={'error'}
                        />
                    }
                />
            </Grid>
            }
            <Grid item xs={12}>
                <Button variant="contained" className={classes.agyleButton} onClick={applyFilter}>Apply</Button>
            </Grid>
            <Grid item xs={12}>
                {filtersChip.map((filter, index)=>{
                    return <Chip key={`chip${index}`} label={filter.value} onDelete={()=>handleDelete(filter)}/>;
                })}
            </Grid>
        </Grid>);
    }
    const getSortIcon = (columnName) => {
        if(columnName !== sortSend) return ""
        if(sortOrder) return <ArrowDropDownIcon/>;
        return <ArrowDropUpIcon/>;

    }

    const addRow = (row) => {
        setSelectedRows((prRows)=> ([...prRows, row]))
    }

    const removeRow = (row) => {
        let selectedRowsTmp = selectedRows.filter(item => item !== row);
        setSelectedRows(selectedRowsTmp);
    }


    return (<div>
        {!props.filterHidden && renderFilters()}
        {!props.filterHidden && selectedRows.length > 0 && <React.Fragment>
            <Button className={classes.agyleButton}
                    style={{marginLeft: '40px'}}
                    onClick={copyRowsMessage}
                    size="small"
                    color="primary"
                    variant="contained">
                {t("copy")}
            </Button>
            <Button className={classes.agyleButton}
                    onClick={resendMessages}
                    size="small"
                    color="primary"
                    variant="contained">
                {t("resend")}
            </Button>
        </React.Fragment> }

        <Paper sx={{width: '100%', overflow: 'hidden', mt: 4}}>
            <TableContainer >
                <Table stickyHeader aria-label="sticky table">
                    <TableHead  key={"HEAD"}>
                        <TableRow>
                            {props.columns.map((column,indexColumn) => {
                                return (
                                    <TableCell
                                        key={indexColumn + "Hasd"}
                                        align={column.align}
                                        style={{
                                            minWidth: column.minWidth,
                                            width: column.maxWidth || getColumnWidth(column),
                                            border: "1px solid #80808035",
                                        }}
                                    >
                                        <Grid container justifyContent="space-between">
                                            <Typography variant="subtitle2"
                                                        color="textSecondary"
                                                        style={{cursor: column.sort? "pointer":""}}
                                                        onClick={()=> {
                                                            if(column.sort) {
                                                                handleSetSort(column)
                                                            }
                                                        }}>
                                                <div style={{display: "flex"}}>
                                                    {column.description} {getSortIcon(column.value)}
                                                </div>

                                            </Typography>
                                            {indexColumn === props.columns.length-1 && <DatabaseIconHL7 onClick={props.openColumnManager}/>}
                                            {column.name === "dateTime" && <DateIconHL7/>}
                                        </Grid>
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {messages?.map((row, rowIndex) => {
                                // console.log("test", row);
                                return <React.Fragment key = {rowIndex+"div"}>
                                    <RowMessage columns = {props.columns}
                                                row = {row} handleAddRow={addRow}
                                                rowIndex={rowIndex}
                                                outcoming = {props.outcoming || false}
                                                messageTypeDict = {messageTypeDict}
                                                handleRemoveRow={removeRow}/>
                                </React.Fragment>
                            })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={8} >
                                Page: {page+1}
                                <IconButton size="small"
                                            disabled={page < 1}
                                            onClick={handleChangePrevPage}>
                                    <NavigateBeforeSharpIcon fontSize="small"/>
                                </IconButton>
                                <IconButton size="small"
                                            disabled={messages.length < pageSize-1}
                                            onClick={handleChangeNextPage}>
                                    <NavigateNextIcon fontSize="small" />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
        </Paper>

    </div>)
}


export default FHIRMessagesTable;